import React from "react";
import ResumeManager from "../../components/resume/ResumeManager";

const ResumeSection = () => {
  return (
    <div>
      <ResumeManager />
    </div>
  );
};

export default ResumeSection;
